import { Helmet } from "react-helmet-async";

const SEO = ({ seo }) => {
  if (!seo) return null;

  return (
    <Helmet>

      {/* General */}

      <title>{seo.title}</title>

      <meta
        name="description"
        content={seo.description}
      />

      <meta
        name="keywords"
        content={seo.keywords}
      />

      <meta
        name="robots"
        content={`${seo.robots?.index ? "index" : "noindex"}, ${
          seo.robots?.follow ? "follow" : "nofollow"
        }`}
      />

      <link
        rel="canonical"
        href={seo.canonicalUrl}
      />

      {/* Open Graph */}

      <meta
        property="og:type"
        content="website"
      />

      <meta
        property="og:title"
        content={seo.ogTitle || seo.title}
      />

      <meta
        property="og:description"
        content={seo.ogDescription || seo.description}
      />

      <meta
        property="og:image"
        content={seo.ogImage}
      />

      <meta
        property="og:url"
        content={seo.canonicalUrl}
      />

      {/* Twitter */}

      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={seo.twitterTitle || seo.title}
      />

      <meta
        name="twitter:description"
        content={seo.twitterDescription || seo.description}
      />

      <meta
        name="twitter:image"
        content={seo.twitterImage}
      />

      {/* Favicon */}

      {seo.favicon && (
        <link
          rel="icon"
          href={seo.favicon}
        />
      )}

      {/* Structured Data */}

      {seo.structuredData && (
        <script type="application/ld+json">
          {typeof seo.structuredData === "string"
            ? seo.structuredData
            : JSON.stringify(seo.structuredData)}
        </script>
      )}

    </Helmet>
  );
};

export default SEO;